import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const ASSET_SIDEBAR_DATA = [
  {
    header: 'UPLOAD',
    tabs: [
      {
        tabName: 'Video',
        to: '/asset-management/upload-video',
        subject: PERMISSION_SUBJECTS.rawAsset,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
      {
        tabName: 'Bulk Upload',
        to: '/asset-management/bulk-upload-video/video-upload-history',
        subject: PERMISSION_SUBJECTS.rawAsset,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
];

export default ASSET_SIDEBAR_DATA;
